import {all, fork} from "redux-saga/effects";
import * as Login from "./login.saga";
import * as Sites from "./sites.saga";
import * as Base from "./base.saga";
import * as Controllers from "./controllers.saga";
import * as Inventories from "./inventories.saga";
import * as Address from "./address.saga";
import * as Reports from "./reports.saga";
import * as Users from "./users.saga";
import * as Group from "./group.saga";
import * as Customers from "./customers.saga";
import * as Contacts from "./contacts.saga";
import * as Alerts from "./alerts.saga";
import * as TSDB from "./tsdb.saga";
import * as DataExplorer from "./data-explorer.saga";
import * as General from "./general.saga";
import * as Notifications from "./notification.saga";
import * as AdvanceTab from "./advanceTab.saga";
import * as ToolsTab from "./toolsTab.saga";
import * as Webhooks from "./webhooks.saga";
import * as CloneProfile from "./cloneProfile.saga";
import * as CustomFields from "./customFields.saga";
import * as EventRules from "./eventRule.saga";

export default function* rootSaga() {
  yield all(
    [
      ...Object.values(Login),
      ...Object.values(Sites),
      ...Object.values(Base),
      ...Object.values(Controllers),
      ...Object.values(Inventories),
      ...Object.values(Address),
      ...Object.values(Reports),
      ...Object.values(Users),
      ...Object.values(Group),
      ...Object.values(Customers),
      ...Object.values(Contacts),
      ...Object.values(Alerts),
      ...Object.values(TSDB),
      ...Object.values(DataExplorer),
      ...Object.values(General),
      ...Object.values(Notifications),
      ...Object.values(AdvanceTab),
      ...Object.values(ToolsTab),
      ...Object.values(Webhooks),
      ...Object.values(CloneProfile),
      ...Object.values(CustomFields),
      ...Object.values(EventRules),
    ].map(fork)
  );
}
